import React from 'react';
import { withStyles } from '@material-ui/styles';
import MuiTableRow from '@material-ui/core/TableRow';

const styles = theme => ({
  root: {
    '&:last-child td': {
      borderBottom: '0rem',
    },
    '&:hover': {
      backgroundColor: theme.palette.secondary['100'],
      '&.rectangle-cell__item': {
        backgroundColor: theme.palette.secondary['100'],
      },
    },
    "&[aria-checked='true']": {
      backgroundColor: theme.palette.secondary['100'],
      '&.rectangle-cell__item': {
        backgroundColor: theme.palette.secondary['100'],
      },
      // row is checked and hovered
      '&:hover': {
        backgroundColor: theme.palette.secondary['100'],
        '&.rectangle-cell__item': {
          backgroundColor: theme.palette.secondary['100'],
        },
      },
    },
  },
});

const TableRow = (props) => {
  const { classes } = props;
  return (
    <MuiTableRow
      classes={{ root: classes.root }}
      {...props}
    >
      {props.children}
    </MuiTableRow>
  );
};

export default withStyles(styles)(TableRow);
